// removed by extract-text-webpack-plugin
module.exports = {"Article":"Article__Article__1XvKp","Header":"Article__Header__1HjoX","Body":"Article__Body__23K8Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Article/Article.css
// module id = 625
// module chunks = 0